// A disclosure that opens itself when its content holds something and never
// closes itself (rev-7 "Other languages" sections).
//
// Deriving `<details open>` from the fields on every render closes the section
// the moment its last field is emptied, under the cursor of the person
// emptying it. Here the content only ever opens it: once at mount when there is
// text, and again if text arrives later (a form filled after its read lands).
// Closing is the reader's own toggle.

import { useEffect, useState, type SyntheticEvent } from "react";

export function useStickyOpen(hasContent: boolean): {
  open: boolean;
  onToggle: (event: SyntheticEvent<HTMLDetailsElement>) => void;
} {
  const [open, setOpen] = useState(hasContent);
  useEffect(() => {
    if (hasContent) setOpen(true);
  }, [hasContent]);
  return {
    open,
    onToggle: (event) => {
      setOpen(event.currentTarget.open);
    },
  };
}
